export default {
  inhale: 5,
  exhale: 5,
  holdInhale: 0,
  holdExhale: 0,
  totalTime: 1,
  isTimerRunning: false,
  interval: null,
  startTime: null,
  endTime: null,
  currentTime: null,
  showClock: false,
};
